// src/components/Jordan/SaversCreditSteps.js
import React from "react";
import { motion } from "framer-motion";
import {
  Sparkles,
  BadgeDollarSign,
  ArrowRight,
  Info,
  BookOpenCheck,
} from "lucide-react";
import SaverCreditTwoUp from "../AMain/SaverCreditTwoUp";
import { useTranslation } from "react-i18next";

// 🔹 Use keys here, NOT t()
const STEPS = [
  {
    id: 1,
    titleKey: "savers-0-1h",
    bodyKey: "savers-0-1",
  },
  {
    id: 2,
    titleKey: "savers-0-2h",
    bodyKey: "savers-0-2",
  },
  {
    id: 3,
    titleKey: "savers-0-3h",
    bodyKey: "savers-0-3",
  },
    {
    id: 4,
    titleKey: "savers-0-4h",
    bodyKey: "savers-0-4",
  }
];

export default function SaversCreditSteps() {
  const { t } = useTranslation();

  return (
<div className="bg-gradient-to-b from-orange-50 via-slate-50 to-slate-100 text-slate-900">

      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:py-14">
        {/* Header / hero */}
        <motion.header
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8 rounded-3xl border border-orange-200 bg-white/80 p-5 shadow-lg sm:p-8"
        >
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-orange-100 px-3 py-1 text-xs font-semibold text-orange-900">
            <Sparkles className="h-4 w-4" />
            <span>{t("savers-tagline", "Saver's Credit overview")}</span>
          </div>

          <p className="mb-3 max-w-3xl text-sm text-slate-700 sm:text-base">
            {t("savers-maincard")}
          </p>
          <p>
            <strong>{t("savers-maincardq")}</strong>
          </p>
          <p>{t("savers-maincarda")}</p>

          <p className="text-xs text-slate-500 sm:text-sm">
            {t("savers-maincardhighlight")}
          </p>
        </motion.header>

        {/* Layout: steps + math summary */}
        <div className="grid gap-6">
          {/* Steps column */}
          <motion.section
            initial={{ opacity: 0, x: -8 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.45, delay: 0.05 }}
            className="space-y-3"
          >
            {STEPS.map((step) => (
              <div
                key={step.id}
                className="flex gap-3 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm sm:p-4"
              >
                <div className="mt-1 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 text-xs font-semibold text-slate-900 sm:h-8 sm:w-8">
                  {step.id}
                </div>
                <div>
                  <h2 className="text-sm font-semibold text-slate-900 sm:text-base">
                    {t(step.titleKey)}
                  </h2>
                  <p className="mt-1 text-xs text-slate-700 sm:text-sm">
                    {t(step.bodyKey)}
                  </p>
                </div>
              </div>
            ))}
          </motion.section>

          {/* Math / rectangle vibe column */}
          <motion.aside
            initial={{ opacity: 0, x: 8 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.45, delay: 0.1 }}
            className="space-y-4"
          >
            {/* You can put SaverCreditTwoUp or other visual blocks here */}
            {/* <SaverCreditTwoUp /> */}
          </motion.aside>
        </div>
      </div>
    </div>
  );
}
